import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

const getSnapshot = () => {
  if (typeof window === "undefined") return false;
  // pointer: coarse = primary input is touch (phone/tablet)
  // pointer: fine = primary input is mouse/trackpad (desktop/laptop)
  return window.matchMedia("(pointer: coarse)").matches;
};

const getServerSnapshot = () => false;

export const useIsTouchDevice = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
